<template>
  <b-container id="journal-view-container">
    <b-row align-v="center" align-h="center">
      <b-col cols="12" md="8">
      <b-modal
                id="modal-create-entry"
                ref="creationModal"
                :header-text-variant="$t('journal:modal-enter')"
                :hide-footer="true"
                @shown="focusOnTextarea">
          <h4 class="journal-entry-timestamp mb-3"> {{ new Date | moment("LL") }} </h4>

          <form @submit.stop.prevent="addJournalEntry()">
            <label name="newEntry"></label>
            <b-form-textarea
                            ref="textarea"
                            id="newEntry"
                            v-model="newEntry.content"
                            :placeholder="$t('journal:modal-enter')"
                            :rows="5"
                            :max-rows="8"
                            :maxlength="journalEntryMaxLength">
            </b-form-textarea>
            <div id="char-info" class="character-counter mt-1 mb-0">
              <span id="create-character-error" v-if="journalEntryMaxLength - newEntry.content.length <= 0">{{ $t('journal:character-limit', { limit: journalEntryMaxLength }) }}</span>
              <span id="create-characters-left" v-else-if="journalEntryMaxLength - showWarningBeforeMaxLength <= newEntry.content.length">{{ journalEntryMaxLength - newEntry.content.length }} / {{ journalEntryMaxLength }}</span>
            </div>
            <div class="text-center py-3 mt-3">
              <b-button id="cancel-new-journal-entry-button" class="mx-1" type="button" @click="hideModal(); clearEntry();" variant="outline-danger">{{ $t('journal:modal-cancel')  }}</b-button>
              <b-button id="save-new-journal-entry-button" class="mx-1" type="submit" :disabled="!entryValid" @click="hideModal" variant="success">{{ $t('journal:modal-save')  }}</b-button>
            </div>
          </form>
        </b-modal>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex'

const MIN_CHARACTERS = 0
const MAX_CHARACTERS = 5000

export default {
  name: 'journal',
  props: ['challengePageId', 'themeId', 'challengeId'],
  data () {
    return {
      journalEntryMaxLength: MAX_CHARACTERS,
      showWarningBeforeMaxLength: 100,
      newEntry: {
        content: ''
      }
    }
  },
  watch: {
    challengePageId: {
      immediate: true,
      handler () {
        this.newEntry.challenge = {
          themeId: this.themeId,
          challengeId: this.challengeId,
          challengePageId: this.challengePageId
        }
      }
    }
  },
  methods: {
    addJournalEntry: function () {
      const newEntryWithReference = Object.assign({}, this.newEntry)
      if (this.challengePageId) {
        newEntryWithReference.challenge = {
          themeId: this.themeId,
          challengeId: this.challengeId,
          challengePageId: this.challengePageId
        }
      }
      this.$store.dispatch('addJournalEntry', newEntryWithReference).then(() => {
        this.$emit('entry-created')
        this.clearEntry()
      })
    },
    hideModal () {
      this.$refs.creationModal.hide()
    },
    clearEntry () {
      this.newEntry.content = ''
    },
    focusOnTextarea () {
      this.$refs.textarea.focus()
    }
  },
  computed: {
    ...mapGetters(['journal', 'journalLoading']),
    entryValid: function () {
      if (this.newEntry.content.length < MIN_CHARACTERS) {
        return false
      } else if (this.newEntry.content.length > MAX_CHARACTERS) {
        return false
      } else {
        return true
      }
    }
  }
}
</script>

<style scoped lang="scss">

.journal-entry-timestamp {
  color: #17B5CF;
  text-align: center;
}

</style>
